import { ChangeDetectorRef, Component, ElementRef, InjectionToken, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonServices } from '../Common/CommonServices';
import { CustomServiceService } from '../Services/custom-service.service';
import { FacebookClient, HostPortalClient, User, Webinar, WebinarClient, WebinarRoom, WebinarRoomOwner, WebinarRoomOwnerDTO } from '../Services/WOWApi.Service';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { VideoRecordingService } from './video-recording-service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { min } from 'moment';
import { Console } from 'console';

@Component({
  selector: 'app-create-webinar',
  templateUrl: './create-webinar.component.html',
  styleUrls: ['./create-webinar.component.css'],
  providers: [NgbCarouselConfig],
  standalone: false
})


export class CreateWebinarComponent implements OnInit {
  @Input() webinarId;
  showSpinner: boolean = false;
  webinarImages: any[] = [];
  form: UntypedFormGroup;
  videoLength: number = 0;
  imgURL: any;
  isCameraAvailable: boolean = false;
  webinarRooms: WebinarRoomOwnerDTO[] = [];
  public message: string;
  public imagePath;
  webinar: Webinar;
  loggedUser: User;
  theFile: any[] = [];
  minDate: any;
  uploadedvideo: any = null;
  MAX_SIZE_IMAGE: number = 5 * 1024 * 1024;
  MAX_SIZE_VIDEO = 250 * 1024 * 1024;
  webinarRoom: WebinarRoom;
  selectedRoomId: number;
  timeSlotOption: any = [];
  dragAreaClass: string;
  draggedFiles: any;
  isRecording = false;
  isMobileView = false;
  subscription: Subscription;
  webinarNameInvalid = false;

  @ViewChild('videoElement') videoElement: any;
  @ViewChild('videoPlayer') videoplayer: ElementRef;

  video: any;
  isPlaying = false;
  displayControls = true;
  isAudioRecording = false;
  isVideoRecording = false;
  videoStream: MediaStream;
  audioRecordedTime;
  videoRecordedTime;
  audioBlobUrl;
  videoBlobUrl;
  audioBlob;
  videoBlob;
  audioName;
  videoName;
  audioStream;
  videoUrl;
  recordedVideoURL;
  audioConf = { audio: true }
  videoConf = { video: { facingMode: "user", width: 320 }, audio: true }
  isEditingVideo = false;
  isEditingImages = false;
  isWebinarNameAvailable = false;
  webinarForEdit: Webinar;
  recordedTImeFromService: number;
  hours: string[] = [];
  durationOptions: number[] = [15, 30, 45, 60, 90, 120, 150, 180, 240, 300, 360]; // 15 min to 6 hours
  IsRunImmediately = false;
  isInputsAllowedEditing = true;
  facebookPageData: any;
  facebook_App_Id: string;
  isShowFacebookPreview = false;

  constructor(private customService: CustomServiceService,
    private formBuilder: UntypedFormBuilder,
    private commonServices: CommonServices,
    private webinarClient: WebinarClient,
    public hostPortal: HostPortalClient,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ref: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private videoRecordingService: VideoRecordingService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private facebookClient: FacebookClient
  ) {
    this.videoRecordingService.recordingFailed().subscribe(() => {
      this.isVideoRecording = false;
      this.ref.detectChanges();
    });

    this.videoRecordingService.getRecordedTime().subscribe((time) => {
      var timesplit = time.split(":");
      var totalSecs = (parseInt(timesplit[0]) * 60) + parseInt(timesplit[1]);
      this.recordedTImeFromService = totalSecs;
      var remainingTime = 180 - totalSecs;

      var remainingSecs = remainingTime % 60;

      this.videoRecordedTime = '0' + Math.trunc(remainingTime / 60).toString() + ":" + (remainingSecs < 10 ? '0' : '') + remainingSecs.toString();
      this.ref.detectChanges();

      if (this.videoRecordedTime == "00:00") {
        this.stopVideoRecording();
      }
    });

    this.videoRecordingService.getStream().subscribe((stream) => {
      this.videoStream = stream;
      this.ref.detectChanges();
    });

    this.videoRecordingService.getRecordedBlob().subscribe((data) => {
      this.videoBlob = data;
      console.log(this.videoBlob);
      this.videoName = data.title;
      this.videoBlobUrl = this.sanitizer.bypassSecurityTrustUrl(data.url);
      this.ref.detectChanges();
    });
  }

  ngOnInit(): void {
    this.loggedUser = this.customService.GetLoggedInUser();
    // Initialize hours array in 12-hour format with AM/PM
    this.initializeHours();
    this.GetTimeSlot();
    this.GetForm();
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.minDate = new Date();

    // Subscribe to date changes to filter hours (after form is initialized)
    setTimeout(() => {
      if (this.form && this.form.controls['StartDate']) {
        this.form.controls['StartDate'].valueChanges.subscribe(() => {
          this.updateAvailableHours();
        });
        // Initial update in case date is already set
        this.updateAvailableHours();
      }
    }, 0);

    if (this.webinarId != 0 && this.webinarId != null) {
      this.GetWebinar(this.webinarId);
    } else {
      this.GetRooms();
    }
  }

  GetRooms() {
    this.webinarClient.getWebinarRoomsByUser(this.loggedUser.id)
      .subscribe(data => {
        this.webinarRooms = data.filter(x => x.isWebinarRoomOwnserAssignmentActive);
        
        this.form.controls['WebinarRoom'].setValidators([Validators.required]);
        if (this.webinarId !== undefined && this.webinarId > 0) {
          if (this.webinarRooms.length == 1) {
            this.selectedRoomId = this.webinarRooms[0].webinarRoomId;
            this.form.controls['WebinarRoom'].patchValue(this.selectedRoomId);
            // this.form.controls['WebinarRoom'].clearValidators();
          } else {
            this.selectedRoomId = this.webinarRooms.find(x => x.webinarRoomId === this.webinarForEdit.roomId)?.webinarRoomId;
            this.form.controls['WebinarRoom'].patchValue(this.selectedRoomId);
          }
          this.form.controls['WebinarRoom'].updateValueAndValidity();
        }
      });
  }

  GetWebinar(id: number) {
    this.showSpinner = true;
    this.webinarClient.getWebinar(id).subscribe(data => {
      this.webinarForEdit = data;
      this.setFormValue(data)
      const startDateTime = new Date(data.startDateTime).getTime();
      const today = new Date().getTime();
      if (today > startDateTime) {
        this.isInputsAllowedEditing = false;
        this.disableWebinarFormExceptMedia();
      }
      this.showSpinner = false;
      this.form.controls['maxSeatsAllowedPerUser'].setValidators([Validators.min(1), Validators.max(this.webinarForEdit.numberOfSeats)]);
      this.form.controls['maxSeatsAllowedPerUser'].updateValueAndValidity();
      this.GetRooms();
    }, error => { this.showSpinner = false; });
  }

  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }

  getFileDetails(e) {
    const isIOSiPhone = this.isIphone();
    const fileSize = e.target.files[0].size;
    //alert(`Uploaded File Size is - ${(fileSize / (1024 * 1024)).toFixed(2)} MB, Please keep below 250 MB if exceeding may cause upload issues.`);
    if (!isIOSiPhone && fileSize > this.MAX_SIZE_VIDEO) {
      this.commonServices.showMessage("error", "Maximum allowed video file size is 250 MB.");
      return;
    }
    if (isIOSiPhone && fileSize > (this.MAX_SIZE_VIDEO * 2)) {
      this.commonServices.showMessage("error", "Maximum allowed video file size is 250 MB.");
      return;
    }
    this.uploadedvideo = e.target.files[0];
    const mimeType = this.uploadedvideo.type;
    if (mimeType.match(/video\/*/) == null) {
      this.message = "Only video are supported.";
      this.commonServices.showMessage("Error", "Only video are supported.");
      return;
    }

    // Calculate video duration
    let isVideoToBeAddedToUrl = true;
    const videoElement = document.createElement('video');
    videoElement.src = URL.createObjectURL(this.uploadedvideo);
    videoElement.onloadedmetadata = () => {
      const durationInSeconds = Math.floor(videoElement.duration);
      this.videoLength = durationInSeconds;

      // Validate duration
      if ((durationInSeconds < 30 || durationInSeconds > 180) && Number(durationInSeconds) != Infinity) {
        this.commonServices.showMessage("Error", "Video should be minimum 30 seconds and maximum 3 minutes, length of the video is " + durationInSeconds + " seconds.", 5);
        this.uploadedvideo = null; // Reset the uploaded video
        isVideoToBeAddedToUrl = false;
      } else {
        this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(videoElement.src);
      }
    };
    // if (isVideoToBeAddedToUrl) {
    //   this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(videoElement.src);
    // } else {
    //   this.videoUrl = null;
    // }
  }

  private isIphone(): boolean {
    return /iPhone/i.test(navigator.userAgent);
  }


  HideImages() {
    if (this.webinarImages.length > 0) {
      return true;
    }
    return false;
  }

  preview(event) {
    if (this.theFile.length === 8) {
      this.commonServices.showMessage("Error", "Maximum 3 images allowed only.");
      return;
    }
    if (!event.target.files) {
      this.commonServices.showMessage("Error", "Please upload an image");
      return;
    }

    // Don't allow file sizes over 3MB
    const files: any = Object.values(event.target.files);
    files.map(file => {
      var mimeType = file.type;
      if (mimeType.match(/image\/*/) == null) {
        this.message = "Only images are supported.";
        this.commonServices.showMessage("Error", "Only images are supported.");
        return;
      }
      else {
        this.message = "";
      }
      if (file.size > this.MAX_SIZE_IMAGE) {
        this.commonServices.showMessage("Error", file.name + " is too large to upload, Maximu allowed size is 3 MB.");
        return false;
      }
      if (this.theFile.some(x => x.file.name === file.name)) {
        this.commonServices.showMessage("Error", "File Name already exists, please select another file.");
        return false;
      }
      for (var i = 0; i < event.target.files.length; i++) {
        if (this.theFile.length === 8) {
          this.commonServices.showMessage("Error", "Maximum 8 images allowed only, some images are not added.");
          return
        }
        var element = event.target.files[i];
        this.theFile.push({ file: event.target.files[i], type: 'image' });
        var imagePath = this.getBase64String(element)
        console.log(this.theFile[0].file.name);
      }
    })

  }

  getBase64String(url) {
    var reader = new FileReader();
    reader.readAsDataURL(url);
    reader.onload = (event) => {
      this.webinarImages.push({
        webinarId: 0,
        webinarImageId: 0,
        image: event.target.result
      });
    }
  }

  GetTimeSlot() {
    this.hostPortal.getTimeSlots().subscribe(response => {
      this.timeSlotOption = response;
      // Store the raw response to access StartTime/EndTime if available
      // The response may need to be cast to access additional properties
    })
  }

  // Convert 12-hour format string (e.g., "12:00 AM") to 24-hour number (0-23)
  convert12HourTo24Hour(time12Hour: string): number {
    if (!time12Hour) return 0;
    const parts = time12Hour.split(' ');
    if (parts.length !== 2) return 0;

    const timePart = parts[0];
    const period = parts[1].toUpperCase();
    const hour12 = parseInt(timePart.split(':')[0]);

    if (period === 'AM') {
      return hour12 === 12 ? 0 : hour12;
    } else { // PM
      return hour12 === 12 ? 12 : hour12 + 12;
    }
  }

  // Convert 24-hour number (0-23) to 12-hour format string (e.g., "12:00 AM")
  convert24HourTo12Hour(hour24: number): string {
    if (hour24 === null || hour24 === undefined) return '';
    const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
    const period = hour24 < 12 ? 'AM' : 'PM';
    return `${hour12.toString().padStart(2, '0')}:00 ${period}`;
  }

  // Initialize all hours in 12-hour format
  initializeHours(): void {
    this.hours = [];
    for (let i = 0; i < 24; i++) {
      const hour12 = i === 0 ? 12 : i > 12 ? i - 12 : i;
      const period = i < 12 ? 'AM' : 'PM';
      this.hours.push(`${hour12.toString().padStart(2, '0')}:00 ${period}`);
    }
  }

  // Update available hours based on selected date
  updateAvailableHours(): void {
    const selectedDate = this.form.controls['StartDate'].value;
    const currentSelectedHour = this.form.controls['StartHour'].value;

    if (!selectedDate) {
      // If no date selected, show all hours
      this.initializeHours();
      return;
    }

    const selected = new Date(selectedDate);
    const today = new Date();

    // Reset hours to all hours first
    this.initializeHours();

    // Check if selected date is today
    const isToday = selected.getDate() === today.getDate() &&
      selected.getMonth() === today.getMonth() &&
      selected.getFullYear() === today.getFullYear();

    if (isToday) {
      // Get current time
      const currentHour = today.getHours();

      // Filter out past hours (including current hour since we set minutes to 00)
      this.hours = this.hours.filter(hourStr => {
        const hour24 = this.convert12HourTo24Hour(hourStr);
        // Only include hours that are in the future
        return hour24 > currentHour;
      });

      // If the currently selected hour is no longer available, clear it
      if (currentSelectedHour && !this.hours.includes(currentSelectedHour)) {
        this.form.controls['StartHour'].setValue(null, { emitEvent: false });
      }
    } else {
      // For future dates, show all hours
      // No need to filter, already initialized with all hours
    }
  }

  // Find timeslot based on selected hour
  findTimeSlotByHour(selectedHour: number): any {
    if (!this.timeSlotOption || this.timeSlotOption.length === 0) {
      return null;
    }

    // Try to find timeslot where the hour falls within StartTime and EndTime
    for (let slot of this.timeSlotOption) {
      if (slot.startTime && slot.endTime) {
        try {
          // Parse time strings (format: "HH:mm:ss" or "HH:mm")
          const startTimeParts = slot.startTime.split(':');
          const endTimeParts = slot.endTime.split(':');

          const startHour = parseInt(startTimeParts[0]);
          const endHour = parseInt(endTimeParts[0]);

          // Handle case where endTime might be next day (e.g., 23:00 - 01:00)
          if (startHour <= endHour) {
            // Normal case: startHour < endHour (e.g., 09:00 - 17:00)
            if (selectedHour >= startHour && selectedHour < endHour) {
              return slot;
            }
          } else {
            // Timeslot spans midnight (e.g., 23:00 - 01:00)
            if (selectedHour >= startHour || selectedHour < endHour) {
              return slot;
            }
          }
        } catch (e) {
          // If parsing fails, continue to next slot
          console.warn('Error parsing timeslot time:', e);
        }
      }
    }

    // Fallback: if no match found or StartTime/EndTime not available, use first timeslot
    return this.timeSlotOption[0];
  }

  SetGrossProjected() {
    this.form.controls["Price"].setValue(this.form.controls["Price"].value ? Number(this.form.controls["Price"].value).toFixed(2) : 0);
    const isFreeBee = this.form.controls["IsFreeBee"].value;

    // If it's a freebie webinar, set Gross Projected Sale and Purchase Cost to 0
    if (isFreeBee) {
      this.form.controls["GrossProjectedSale"].setValue(0);
      this.form.controls["PurchaseCost"].setValue(0);
      return;
    }

    var numberOfSeats = this.form.controls["NumberOfSeat"].value;
    if (numberOfSeats !== null && numberOfSeats !== undefined && numberOfSeats !== '' && Number(numberOfSeats) <= 1) {
      this.commonServices.showMessage('error', 'Number of seats must be greater than 1.');
    }
    var price = this.form.controls["Price"].value;
    if (numberOfSeats != null && price != null && Number(numberOfSeats) > 1) {
      this.form.controls["GrossProjectedSale"].setValue((Number(numberOfSeats) * Number(price)).toFixed(2));

      this.form.controls['maxSeatsAllowedPerUser'].setValidators([Validators.min(1), Validators.max(Number(numberOfSeats))]);
      this.form.controls['maxSeatsAllowedPerUser'].updateValueAndValidity();
    }
    if (this.webinarId !== undefined && this.webinarId > 0) {
      this.commonServices.showMessage('success', `please update 'Purchase Cost' also if any changes`, 10);
    }
  }

  GetForm() {
    let numberRegEx = /\-?\d*\.?\d{1,2}/;
    this.form = this.formBuilder.group({
      Name: ['', Validators.required],
      NumberOfSeat: ['', { validators: [Validators.required, Validators.pattern(numberRegEx), Validators.min(2)], updateOn: "blur" }],
      Price: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{0,2})?$/)]],
      GrossProjectedSale: ['', [Validators.required]],
      PurchaseCost: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{0,2})?$/)]],
      Description: [''],
      TimeSlot: [''], // Hidden field, default value will be set when sending to API
      WebinarRoom: ['', Validators.required],
      StartDate: ['', Validators.required],
      StartHour: ['', Validators.required],
      IsCameraAvailable: [this.isCameraAvailable],
      maxSeatsAllowedPerUser: [null, [Validators.required, Validators.min(1)]],
      IsFreeBee: [false],
      DurationInMinutes: [null],
      IsPostToFacebook: [false]
    });

    // Watch for IsFreeBee changes to update validators
    // FreeBie webinars work like regular webinars, just with price = 0
    // Duration field is kept for future flash webinar requirement but not used for FreeBie
    this.form.get('IsFreeBee').valueChanges.subscribe(isFreeBee => {
      if (isFreeBee) {
        // For FreeBie: set values to 0, but keep all validators (same as regular webinar)
        // This ensures FreeBie works exactly like regular webinar, just with free seats
        this.form.get('Price').setValue(0);
        this.form.get('GrossProjectedSale').setValue(0);
        this.form.get('PurchaseCost').setValue(0);
        // Duration is not required for FreeBie (will be used for future flash webinar)
        this.form.get('DurationInMinutes').clearValidators();
        this.form.get('DurationInMinutes').setValue(null);
      } else {
        // For regular webinar: clear price and recalculate
        if (this.webinarId === undefined || this.webinarId === null) {
          this.form.get('Price').setValue('');
          this.form.get('DurationInMinutes').clearValidators();
          this.form.get('DurationInMinutes').setValue(null);
        }
        // Recalculate Gross Projected Sale when switching back to paid webinar
        this.SetGrossProjected();
      }
      // Note: Validators remain the same for both FreeBie and regular webinars
      // FreeBie just has values set to 0
      this.form.get('Price').updateValueAndValidity();
      this.form.get('GrossProjectedSale').updateValueAndValidity();
      this.form.get('PurchaseCost').updateValueAndValidity();
      this.form.get('DurationInMinutes').updateValueAndValidity();
    });
  }

  changeRadioValue() {
    this.isCameraAvailable = this.form.get('IsCameraAvailable').value;
    if (this.isCameraAvailable == false) {
      this.recordedTImeFromService = 0;
    } else {
      this.uploadedvideo = null;
    }
  }

  GetFormData() {
    this.webinar = new Webinar();
    let selectedDate: any;;
    let selectedHour12: any;;
    if (this.isInputsAllowedEditing === false && this.webinarForEdit !== undefined && this.webinarForEdit !== null) {
      this.webinar.name = this.webinarForEdit.name;
      this.webinar.numberOfSeats = this.webinarForEdit.numberOfSeats;
      this.webinar.pricePerSeat = this.webinarForEdit.pricePerSeat;
      this.webinar.grossProjectedSale = this.webinarForEdit.grossProjectedSale;
      this.webinar.purchaseCost = this.webinarForEdit.purchaseCost;
      this.webinar.description = this.webinarForEdit.description;
      this.webinar.maxSeatsAllowedPerUser = this.webinarForEdit.maxSeatsAllowedPerUser;
      this.webinar.isFreeBee = this.webinarForEdit.isFreeBee || false;
      this.webinar.roomId = this.webinarForEdit.roomId;

      // Combine date and hour, set minutes to 00
      const date = new Date(this.webinarForEdit.startDateTime);
      const hour24 = date.getHours();
      const hour12 = this.convert24HourTo12Hour(hour24);
      selectedDate = date;
      selectedHour12 = hour12;
    } else {
      this.webinar.name = this.form.controls["Name"].value;
      this.webinar.numberOfSeats = this.form.controls["NumberOfSeat"].value;
      this.webinar.pricePerSeat = this.form.controls["Price"].value;
      this.webinar.grossProjectedSale = this.form.controls["GrossProjectedSale"].value;
      this.webinar.purchaseCost = this.form.controls["PurchaseCost"].value;
      this.webinar.description = this.form.controls["Description"].value;
      this.webinar.maxSeatsAllowedPerUser = this.form.controls["maxSeatsAllowedPerUser"].value;
      this.webinar.isFreeBee = this.form.controls["IsFreeBee"].value || false;

      // Combine date and hour, set minutes to 00
      selectedDate = this.form.controls["StartDate"].value;
      selectedHour12 = this.form.controls["StartHour"].value;

      if (this.webinarRooms.length > 1) {
        this.webinar.roomId = this.form.controls["WebinarRoom"].value;
      }
      else {
        this.webinar.roomId = this.selectedRoomId;
      }
    }

    this.webinar.name = this.form.controls["Name"].value;
    this.webinar.createdBy = this.loggedUser.id;
    this.webinar.modifiedBy = this.loggedUser.id;

    if (selectedDate && selectedHour12 !== null && selectedHour12 !== undefined && selectedHour12 !== '') {
      const date = new Date(selectedDate);
      // Convert 12-hour format to 24-hour format
      const hourValue = this.convert12HourTo24Hour(selectedHour12);
      if (this.IsRunImmediately) {
        const hourValue = new Date().getHours();
        const minuteValue = new Date().getMinutes();
        date.setHours(hourValue, minuteValue, 0, 0);
        this.webinar.startDateTime = date;
      } else {
        date.setHours(hourValue, 0, 0, 0); // Set minutes to 00
        this.webinar.startDateTime = date;
      }

      // Set timeslot based on selected hour (using 24-hour format)
      if (!isNaN(hourValue)) {
        const matchingTimeSlot = this.findTimeSlotByHour(hourValue);
        if (matchingTimeSlot) {
          this.webinar.timeSlotId = matchingTimeSlot.id;
        } else if (this.timeSlotOption && this.timeSlotOption.length > 0) {
          // Fallback to first timeslot if no match found
          this.webinar.timeSlotId = this.timeSlotOption[0].id;
        } else {
          // Final fallback
          this.webinar.timeSlotId = 1;
        }
      } else {
        // If hour is invalid, use first timeslot
        if (this.timeSlotOption && this.timeSlotOption.length > 0) {
          this.webinar.timeSlotId = this.timeSlotOption[0].id;
        } else {
          this.webinar.timeSlotId = 1;
        }
      }
    } else {
      this.webinar.startDateTime = selectedDate;
      // If hour not selected, use first timeslot
      if (this.timeSlotOption && this.timeSlotOption.length > 0) {
        this.webinar.timeSlotId = this.timeSlotOption[0].id;
      } else {
        this.webinar.timeSlotId = 1;
      }
    }
    this.webinar.ownerId = this.webinarRooms[0].roomOwnerId;
  }

  convertDurationtoSeconds(duration) {
    const [minutes, seconds] = duration.split(':');
    return Number(minutes) * 60 + Number(seconds);
  }

  Reset() {
    this.form.reset();
    this.form.markAsPristine();
    this.form.markAsUntouched();
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key).setErrors(null);
    });
    this.webinarId = 0;
    this.theFile = [];
    this.webinarImages = [];
    this.uploadedvideo = null;
    this.videoUrl = null;
    this.stopVideoRecording();
    this.clearVideoRecordedData();
  }

  onDeleteVideo() {
    this.uploadedvideo = null;
    this.videoUrl = null;
    this.stopVideoRecording();
    this.clearVideoRecordedData();
  }

  async SaveWebinar() {
    if (this.isInputsAllowedEditing === true) {
      if (this.selectedRoomId === undefined || this.selectedRoomId === null) {
        this.commonServices.showMessage('error', 'Please select webinar room.', 5);
        return;
      }
      // let webinarNameValidatiion = false;
      // if ((this.isWebinarNameAvailable === false || this.webinarNameInvalid === true) && this.form.controls.Name.value.trim().length > 0) {
      //   webinarNameValidatiion = await this.checkWebinarNameAvailable(this.form.controls.Name.value);
      // } else {
      //   webinarNameValidatiion = this.isWebinarNameAvailable;
      // }
      if (!this.form.controls.StartDate.valid) {
        this.commonServices.showMessage('error', 'Please select Webinar Date.', 5);
        return;
      }
      if (!this.form.controls.StartHour.valid || this.form.controls.StartHour.value === null || this.form.controls.StartHour.value === undefined || this.form.controls.StartHour.value === '') {
        this.commonServices.showMessage('error', 'Please select webinar posting time.', 5);
        return;
      }
      // if (webinarNameValidatiion !== true) {
      //   this.commonServices.showMessage('error', 'The webinar name is already taken, please change the webinar name to proceed.', 5);
      //   return
      // }
      const isFreeBee = this.form.controls["IsFreeBee"].value;
      // FreeBie webinars work like regular webinars, just with price = 0
      // Duration validation removed for FreeBie (will be used for future flash webinar requirement)
      if (!isFreeBee) {
        if (!this.form.controls.Price.valid || this.form.controls.Price.value === undefined || this.form.controls.Price.value === '' || Number(this.form.controls.Price.value) <= 0) {
          this.commonServices.showMessage('error', 'Price must be greater than 0.', 10);
          return;
        }
        if (!this.form.controls.PurchaseCost.valid || this.form.controls.PurchaseCost.value === undefined || this.form.controls.PurchaseCost.value === '' || Number(this.form.controls.PurchaseCost.value) <= 0) {
          this.commonServices.showMessage('error', 'Purchase Cost must be greater than 0.', 10);
          return;
        }
      }
      if (!this.form.controls.NumberOfSeat.valid || this.form.controls.NumberOfSeat.value === undefined || this.form.controls.NumberOfSeat.value === '' || Number(this.form.controls.NumberOfSeat.value) <= 1) {
        this.commonServices.showMessage('error', 'Number of seats must be greater than 1.', 10);
        return;
      }
      // Skip Purchase Cost validation for freebie webinars
      if (!isFreeBee) {
        if (Number(this.form.controls.PurchaseCost.value) === Number(this.form.controls.GrossProjectedSale.value)) {
          this.commonServices.showMessage('error', 'Purchase cost can not be equal to gross projected sale.', 10);
          return;
        }
        if (Number(this.form.controls.PurchaseCost.value) > Number(this.form.controls.GrossProjectedSale.value)) {
          this.commonServices.showMessage('error', 'Purchase cost can not be greater than gross projected sale.', 10);
          return;
        }
      }
      // Only validate maxSeatsAllowedPerUser if a value is provided
      if (this.form.controls.maxSeatsAllowedPerUser.value !== null && this.form.controls.maxSeatsAllowedPerUser.value !== undefined && this.form.controls.maxSeatsAllowedPerUser.value !== '') {
        if (Number(this.form.controls.maxSeatsAllowedPerUser.value) > Number(this.form.controls.NumberOfSeat.value)) {
          this.commonServices.showMessage('error', 'The maximum seats allowed per user cannot exceed the total number of seats.', 10);
          return;
        }
        if (Number(this.form.controls.maxSeatsAllowedPerUser.value) <= 0) {
          this.commonServices.showMessage('error', 'Minimum Seats Allowed Per User must be at least 1.', 10);
          return;
        }
      }
      // if (this.webinarId !== undefined && this.webinarId > 0 && this.webinarForEdit.name === this.form.controls["Name"].value) {
      //   this.isWebinarNameAvailable === true;
      // } else {
      //   if (this.isWebinarNameAvailable === false) {
      //     this.commonServices.showMessage('error', 'The webinar name is already taken, Please change webinar name to proceed', 10);
      //     return;
      //   }
      // }
      if (!this.form.valid) {
        this.commonServices.showMessage('error', 'Please fill all the required fields to proceed.', 5)
        return;
      }
    }
    this.showSpinner = true;
    this.GetFormData();
    // creating the webinar
    if ((this.webinarId === 0 || this.webinarId === undefined || this.webinarId === null) || (this.isEditingImages && this.isEditingVideo)) {
      if (this.isCameraAvailable && this.recordedTImeFromService > 0 && (this.uploadedvideo === null || this.uploadedvideo === undefined)) {
        this.webinar.videoLengthInSec = this.recordedTImeFromService;
      }
      if (this.theFile.length == 0) {
        this.showSpinner = false;
        this.commonServices.showMessage("Error", "Please upload an image");
        return false;

      }
      if ((this.videoBlob == null || this.videoBlob == undefined) && (this.uploadedvideo == null || this.uploadedvideo == undefined)) {
        this.showSpinner = false;
        this.commonServices.showMessage("Error", "Please upload a video");
        return false;
      }
      if (this.uploadedvideo == undefined && (this.webinar.videoLengthInSec < 30 || this.webinar.videoLengthInSec > 180)) {
        this.showSpinner = false;
        this.commonServices.showMessage("Error", "Video should be minimum 30 Sec and Max 3 minutes");
        return false;
      }
    }

    this.webinar.statusId = 1;
    // when editing the webinar
    if (this.isEditingImages && !this.theFile.some(x => x.type === 'image')) {
      this.commonServices.showMessage('Error', 'Please upload images to update.', 5);
      return;
    }
    if (this.isEditingVideo && !this.theFile.some(x => x.type === 'video') && this.uploadedvideo == null) {
      this.commonServices.showMessage('Error', 'Please upload/record video to update.', 5);
      return;
    }
    if (this.webinarId !== undefined && this.webinarId !== 0 && this.webinarId > 0) {
      this.webinar.webinarId = this.webinarId;
    }
    if (this.uploadedvideo)
      this.webinar.videoLengthInSec = this.videoLength;
    if (!this.isEditingImages && !this.isEditingVideo && this.webinarId === 0 && this.theFile.length === 0) {
      this.commonServices.showMessage('Error', 'Please upload/record video & upload images to proceed.', 5);
      return;
    }
    const addWebinar = this.webinarClient.webinar(this.webinar);
    const updateWebinar = this.webinarClient.updateWebinar(this.webinar);
    const api: any = (this.webinarId !== undefined && this.webinarId !== 0 && this.webinarId > 0) ? updateWebinar : addWebinar;

    api.subscribe(x => {
      if (x === null) {
        this.commonServices.showMessage('error', 'Could not create/update webinar, please re-try after some time', 5);
        return;
      }
      if (x.errors?.length > 0) {
        this.showSpinner = false;
        this.commonServices.showMessage("Error", x.errors[0]);
        return false;
      }
      // when editing/creating the webinar
      if (this.webinarId === 0 || this.webinarId === undefined || this.webinarId === null || this.isEditingVideo || this.isEditingImages) {
        if (this.isCameraAvailable) {
          if (this.videoBlob) {
            var file = new File([this.videoBlob.blob], 'RecordedVideo.mp4', { type: 'video/mp4', lastModified: new Date().getTime() });
            this.theFile.push({ file: file, type: 'video' });
          }
        }
        else {
          if (this.uploadedvideo)
            this.theFile.push({ file: this.uploadedvideo, type: 'video' });
          this.webinar.videoLengthInSec = 0;
        }

        const addUploadApi = this.isIphone() ? this.customService.UploadWebinarImageIphone(this.theFile, x.webinarId) : this.customService.UploadWebinarImage(this.theFile, x.webinarId);
        const updateUploadApi = this.isIphone() ? this.customService.UpdateWebinarUploadedBlobsIphone(this.theFile, this.webinarId) : this.customService.UpdateWebinarUploadedBlobs(this.theFile, this.webinarId);
        const uploadApi = (this.isEditingImages || this.isEditingVideo) ? updateUploadApi : addUploadApi;

        uploadApi.subscribe(resp => {
          this.showSpinner = false;
          if (this.form.controls['IsPostToFacebook'].value === true) {
            this.postToFacebookPage(this.form.controls['Name'].value, x.webinarId);
          }
          if (this.isEditingImages || this.isEditingVideo) {
            this.commonServices.showMessage("success", "Webinar Updated successfully", 5);
          } else {
            this.commonServices.showMessage("success", "Webinar Created successfully", 5);
          }
          this.Reset(); // Reset the form after successful create/update
        }, error => {
          this.commonServices.showMessage('error', error, 5);
          this.showSpinner = false;
          if ((this.webinarId === 0 || this.webinarId === undefined || this.webinarId === null) && !this.isEditingImages && !this.isEditingVideo) {
            this.onDeleteWebinar(x.webinarId);
          }
        });
      } else {
        this.commonServices.showMessage("success", "Operation completed successfully", 5);
      }
    }, error => {
      this.showSpinner = false;
      this.commonServices.showMessage('error', `Could not create webinar - ${error}`, 5);
    });

  }

  setFormValue(webinarData: Webinar) {
    this.form.controls["Name"].setValue(webinarData.name);
    this.form.controls["NumberOfSeat"].setValue(webinarData.numberOfSeats);
    this.form.controls["Price"].setValue(webinarData.pricePerSeat);
    this.form.controls["GrossProjectedSale"].setValue(webinarData.grossProjectedSale);
    this.form.controls["PurchaseCost"].setValue(webinarData.purchaseCost);
    this.form.controls["Description"].setValue(webinarData.description);
    // TimeSlot is hidden, no need to set form value
    this.form.controls["StartDate"].setValue(webinarData.startDateTime);

    // Update available hours based on the date (before setting hour value)
    this.updateAvailableHours();

    // Extract hour from the date and convert to 12-hour format
    if (webinarData.startDateTime) {
      const date = new Date(webinarData.startDateTime);
      const hour24 = date.getHours();
      const hour12 = this.convert24HourTo12Hour(hour24);
      // Only set the hour if it's still available after filtering
      if (this.hours.includes(hour12)) {
        this.form.controls["StartHour"].setValue(hour12);
      } else {
        this.form.controls["StartHour"].setValue(null);
      }
    }
    this.form.controls["IsFreeBee"].setValue(webinarData.isFreeBee || false);
    this.form.controls["DurationInMinutes"].setValue(webinarData.durationInMinutes);
    this.form.controls["maxSeatsAllowedPerUser"].setValue(webinarData.maxSeatsAllowedPerUser || null);
  }

  async startVideoRecording() {
    navigator.mediaDevices
      .getUserMedia({
        video: {
          width: 360
        }
      })
      .then(stream => {
        this.video = this.videoElement.nativeElement;
      })
      .catch(err => {
        console.error('getUserMedia() failed: ', err);
      }
      );

    const devices = await navigator.mediaDevices.enumerateDevices();
    console.log(devices);
    if (devices.some(x => x.kind === 'videoinput') === false) {
      this.commonServices.showMessage('X', `Video device not connected or unable to detect the device, please check again to proceed.`, 5, 'top');
      return;
    }
    if (devices.some(x => x.kind === 'audioinput') === false) {
      this.commonServices.showMessage('X', `Audio device not connected or unable to detect the device, please check again to proceed.`, 5, 'top');
      return;
    }
    await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      .catch(err => {
        this.commonServices.showMessage('X', `Please provide camera & audio permission to record Video while creating webinar`, 10, 'top');
        return;
      });

    if (!this.isVideoRecording) {
      this.video.controls = false;
      this.isVideoRecording = true;
      this.videoRecordingService.startRecording(this.videoConf)
        .then(stream => {
          // this.video.src = window.URL.createObjectURL(stream);
          this.video.srcObject = stream;
          this.video.play();
        })
        .catch(function (err) {
          console.log(err.name + ": " + err.message);
        });
    }
  }

  abortVideoRecording() {
    if (this.isVideoRecording) {
      this.isVideoRecording = false;
      this.videoRecordingService.abortRecording();
      this.video.controls = false;
    }
  }

  stopVideoRecording() {
    if (this.isVideoRecording) {
      this.videoRecordingService.stopRecording();
      this.video.srcObject = this.videoBlobUrl;
      // this.recordedVideoURL = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.videoBlobUrl));
      this.isVideoRecording = false;
      this.video.controls = true;
    }
  }

  clearVideoRecordedData() {
    this.videoBlobUrl = null;
    this.video.srcObject = null;
    this.video.controls = false;
    this.ref.detectChanges();
  }
  _downloadFile(data: any, type: string, filename: string): any {
    const anchor = document.createElement('a');
    anchor.download = filename;
    anchor.href = data.url;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  downloadVideoRecordedData() {
    this._downloadFile(this.videoBlob, 'video/mp4', this.videoName);
  }

  getDuration(e) {
    this.videoRecordedTime = e.target.duration;
  }

  onChangeIsEditImagesCheckbox() {
    this.isEditingImages = !this.isEditingImages;
    if (this.theFile.length > 0) {
      this.theFile.map((x, i) => {
        if (x.type === 'image') {
          this.theFile.splice(i, 1);
        }
      });
    }
  }

  onChangeIsEditVideoCheckbox() {
    this.isEditingVideo = !this.isEditingVideo;
    if (this.theFile.length > 0) {
      this.theFile.map((x, i) => {
        if (x.type === 'video') {
          this.theFile.splice(i, 1);
        }
      });
    }
    this.uploadedvideo = null;
    this.video = undefined;
    this.videoBlob = undefined;
  }

  onDeleteImage(idx: number) {
    this.theFile.splice(idx, 1);
    this.webinarImages.splice(idx, 1);
  }

  onSelectWebinarRoom(webinarRoomId: number) {
    this.selectedRoomId = webinarRoomId;
    sessionStorage.setItem('selectedWebinarRoomId', webinarRoomId.toString());
  }

  get selectedRoomName(): string {
    return this.webinarRooms?.find(x => x.webinarRoomId === this.selectedRoomId)?.roomName || '';
  }

  checkWebinarNameAvailable(webinarName: string): Promise<any> {
    return new Promise((resolve, rejects) => {
      this.webinarNameInvalid = false;
      if (webinarName.trim().length === 0 || webinarName === undefined || webinarName === null) {
        this.commonServices.showMessage('error', 'Please provide webinar title to proceed..', 5);
        return;
      }
      if (this.selectedRoomId === undefined || this.selectedRoomId === null) {
        this.commonServices.showMessage('error', 'Please select webinar room..', 5);
        this.form.controls['WebinarRoom'].markAsTouched();
        return;
      }
      if (webinarName.trim().length <= 2 && webinarName.trim().length > 0) {
        this.commonServices.showMessage('error', 'Please provide valid webinar name.', 5);
        this.webinarNameInvalid = true;
        return;
      }
      if (this.selectedRoomId !== undefined && this.selectedRoomId !== null && this.selectedRoomId !== 0 && this.selectedRoomId > 0) {
        if (this.webinarId !== undefined && this.webinarId > 0) {
          if (webinarName === this.webinarForEdit.name) {
            this.isWebinarNameAvailable = true;
            this.webinarNameInvalid = false;
            resolve(true);
            return;
          }
        }
        this.webinarClient.checkWebinarNameIsAvailable(webinarName, this.selectedRoomId).subscribe(res => {
          if (res === true) {
            this.commonServices.showMessage('success', 'Webinar name is available', 5);
            this.isWebinarNameAvailable = true;
            this.webinarNameInvalid = false;
            resolve(true);
          }
          if (res === false) {
            this.form.controls.Name.reset();
            this.commonServices.showMessage('error', 'Webinar name not available, please try another name', 5);
            this.isWebinarNameAvailable = false;
            this.webinarNameInvalid = true;
            resolve(false);
          }
        }, error => {
          this.commonServices.showMessage("error", error, 5);
          this.isWebinarNameAvailable = false;
          this.webinarNameInvalid = true;
        })
      }
    })
  }

  onlyDecimalAllowed(event: KeyboardEvent) {
    const inputElement = event.target as HTMLInputElement;
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

    // Allow control keys
    if (allowedKeys.includes(event.key)) return;

    const char = event.key;

    // Allow only digits and dot
    if (!/^[0-9.]$/.test(char)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Decimal only', 2);
      return;
    }

    const currentValue = inputElement.value;
    const proposedValue =
      currentValue.substring(0, inputElement.selectionStart!) +
      char +
      currentValue.substring(inputElement.selectionEnd!);

    // Validate full value: only one dot, max 3 digits after dot
    const regex = /^\d+(\.\d{0,3})?$/;
    if (!regex.test(proposedValue)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Only up to 2 decimal places allowed', 2);
    }
  }

  onlyNumbers(event: KeyboardEvent) {
    const input = String.fromCharCode(event.charCode);
    const pattern = /^[0-9]+$/;
    if (!pattern.test(input)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Numbers only', 2);
    }
  }

  isPurchaseCostValid() {
    const isFreeBee = this.form.controls["IsFreeBee"].value;

    // Skip validation for freebie webinars
    if (isFreeBee) {
      return true;
    }

    if (this.form.controls.NumberOfSeat.valid && this.form.controls.Price.valid && this.form.controls.PurchaseCost.valid && this.form.controls.GrossProjectedSale.valid) {
      if (Number(this.form.controls.PurchaseCost.value) >= Number(this.form.controls.GrossProjectedSale.value)) {
        this.commonServices.showMessage('error', 'Purchase Cost must be less than Gross Projected Sale, Please update to proceed.', 5);
        return false;
      }
    } else {
      if (!this.form.controls.NumberOfSeat.valid) {
        this.commonServices.showMessage('error', 'Please provide valid seats.', 5);
      }
      if (!this.form.controls.Price.valid) {
        this.commonServices.showMessage('error', 'Please provide valid price.', 5);
      }
    }
  }

  onDeleteWebinar(webinarId: number) {
    this.webinarClient.deleteUnsusedWebinar(webinarId).subscribe(res => {
      if (res === true) {
        console.log('Webinar deleted successfully.');
      } else {
        console.log('Could not delete the created webinar.');
      }
    }, error => {
      this.commonServices.showMessage('error', error, 10);
    });
  }

  onChangeToRunWebinarImmediately(isChecked: MatCheckboxChange) {
    if (isChecked.checked) {
      this.form.controls["StartDate"].setValue(new Date());
      // updateAvailableHours will be called automatically via the subscription
      // Wait a moment for the hours to update, then set the first available hour
      setTimeout(() => {
        if (this.hours && this.hours.length > 0) {
          // Set the first available hour (next hour after current)
          this.form.controls["StartHour"].setValue(this.hours[0]);
        } else {
          // If no hours available (unlikely, but handle edge case), set current hour
          const currentHour24 = new Date().getHours();
          const currentHour12 = this.convert24HourTo12Hour(currentHour24 + 1); // Next hour
          this.form.controls["StartHour"].setValue(currentHour12);
        }
      }, 100);
      this.IsRunImmediately = true;
    } else {
      this.form.controls["StartDate"].setValue(null);
      this.form.controls["StartHour"].setValue(null);

      this.IsRunImmediately = false;
    }
  }

  disableWebinarFormExceptMedia() {
    this.form.controls["Name"].disable();
    this.form.controls["NumberOfSeat"].disable();
    this.form.controls["Price"].disable();
    this.form.controls["GrossProjectedSale"].disable();
    this.form.controls["PurchaseCost"].disable();
    this.form.controls["Description"].disable();
    this.form.controls["StartDate"].disable();
    this.form.controls["StartHour"].disable();
    this.form.controls["IsFreeBee"].disable();
    this.form.controls["DurationInMinutes"].disable();
    this.form.controls["WebinarRoom"].disable();
    this.form.controls["maxSeatsAllowedPerUser"].disable();

    this.form.updateValueAndValidity();
  }

  onChangePostOnFacebook(event: MatCheckboxChange) {
    if (event.checked) {
      this.form.markAllAsTouched();
      if (this.selectedRoomId === undefined || this.selectedRoomId === null || this.form.controls['Name'].invalid || this.form.controls['StartDate'].invalid
         || this.form.controls['NumberOfSeat'].invalid || this.form.controls['Description'].invalid || this.form.controls['StartHour'].invalid) {
        this.commonServices.showMessage(
          'error',
          'Please fill required details before posting to Facebook.',
          5
        );
        this.form.controls['IsPostToFacebook'].setValue(false);
        return;
      }

      this.loginWithFacebookPopup();

    } else {
      sessionStorage.removeItem('fb_access_token');
      this.form.controls['IsPostToFacebook'].setValue(false);
    }
  }

  loginWithFacebookPopup() {

    // const fb_token_data = sessionStorage.getItem('fb_token_data');
    // if (fb_token_data !== null && fb_token_data !== undefined) {
    //   const tokenData = JSON.parse(fb_token_data || '{}');
    //   const fb_access_token = tokenData.access_token;
    //   const expiresIn = tokenData.expires_in;
    //   console.log('FB Token Data from session:', tokenData);
    //   console.log(new Date(Number(tokenData.data_access_expiration_time) * 1000));
    //   if (Number(expiresIn) > 900) {
    //     this.getFacebookPages(fb_access_token);
    //     return;
    //   }
    // }

    const clientId =
      this.webinarRooms.find(x => x.webinarRoomId === this.selectedRoomId)
        ?.facebook_App_Id;

    if (!clientId || clientId.trim().length === 0) {
      this.commonServices.showMessage(
        'error',
        'Facebook App ID is not configured for the selected webinar room.',
        10
      );
      this.form.controls['IsPostToFacebook'].setValue(false);
      return;
    }

    const redirectUri = encodeURIComponent(
      window.location.origin + '/assets/fb-auth.html'
    );

    const scope = encodeURIComponent(
      'pages_show_list,pages_manage_posts,pages_read_engagement'
    );

    const state = encodeURIComponent(JSON.stringify({ ts: Date.now() }));

    const url =
      'https://www.facebook.com/v18.0/dialog/oauth' +
      `?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=token` +
      `&scope=${scope}` +
      `&state=${state}`;

    window.addEventListener('message', this.onFacebookAuthMessage, false);

    window.open(url, 'fbLogin', 'width=600,height=700');
  }

  onFacebookAuthMessage = (event: MessageEvent) => {

    if (event.origin !== window.location.origin) return;

    if (event.data?.type === 'FB_AUTH_SUCCESS') {

      const paramsObj = event.data.payload;

      sessionStorage.setItem('fb_token_data', JSON.stringify(paramsObj));

      if (paramsObj.access_token) {
        sessionStorage.setItem('fb_access_token', paramsObj.access_token);
        this.getFacebookPages(paramsObj.access_token);
      }

      window.removeEventListener('message', this.onFacebookAuthMessage);
    }
  };

  getFacebookPages(accessToken: string) {
    this.facebookClient.pages(accessToken).subscribe((pages: any) => {
      this.facebookPageData = pages.data[0];
      this.form.controls['IsPostToFacebook'].setValue(true);
      this.form.controls['WebinarRoom'].setValue(
        parseInt(sessionStorage.getItem('selectedWebinarRoomId') || '0')
      );
      sessionStorage.removeItem('selectedWebinarRoomId');
      this.isShowFacebookPreview = true;
    }, error => {
      console.error('Error fetching Facebook pages:', error);
      this.isShowFacebookPreview = false;
    });
  }

  onFacebookPostGenerated(image: any) {
    this.facebookPageData.image = image;
  }

  postToFacebookPage(webinarName: string, webinarId: number) {
    const caption =
      'Check out our new webinar ' +
      webinarName +
      ' at ' +
      window.location.origin +
      '/Webinar/' +
      webinarId;

    this.customService.postFacebookImage(
      this.facebookPageData.image,
      this.facebookPageData.id,
      this.facebookPageData.access_token,
      caption
    ).subscribe(() => {
      this.commonServices.showMessage(
        'success',
        'Successfully posted to Facebook page.',
        10
      );
    }, error => {
      this.commonServices.showMessage(
        'error',
        `Error posting to Facebook: ${error}`,
        10
      );
    });
  }
}

